import { POST } from "./_config";

export const superAdminLoginApi = async (body: any) =>
  await POST(`/super-admin/auth/login`, body);

const AuthService = {
  superAdminLoginApi,
};

export default AuthService;
